import React from "react"
import Link from "@components/link"

import getValue from "get-value"

const Intro = () => {
  return (
    <div className="px-4 mb-16 text-center">
      <h4 className="mb-2 text-sm antialiased not-italic leading-5 tracking-widest uppercase text-dark-gray font-medium">
        Join The Team
      </h4>
      <div className="max-w-5xl mx-auto mb-2 text-2xl font-bold text-center text-gray-900 sm:text-4xl text-dark-navy">
        <h2 className="">
          Ready to make a difference for pets and their humans?
        </h2>
      </div>
    </div>
  )
}

const Filter = ({ onFilter, departments }) => {
  const handleChange = event => {
    onFilter(event.target.value)
  }

  return (
    <div className="text-center">
      <label
        htmlFor="jobsFilter"
        className="block mb-4 text-sm antialiased not-italic leading-5 tracking-widest uppercase md:mb-4 text-dark-gray font-medium"
      >
        Browse Careers
      </label>
      <div className="max-w-3xl mx-auto mb-2 text-xl font-bold text-dark-gray sm:text-2xl">
        <select
          id="jobsFilter"
          onChange={handleChange}
          className="border-b border-dark-navy"
        >
          <option value="*">All Teams</option>
          {departments.map((name, index) => (
            <option key={`departmentOption-${index}`} value={name}>
              {name}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

const GreenhouseList = ({ title, subtitle }) => {
    return (
      <div className="max-w-screen-xl mx-auto">
        <Intro />
        <div className="px-4 pt-16 pb-20 bg-white sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
          <div className="container relative mx-auto" id="jobs">
            <p className="text-center">No available jobs.</p>
          </div>
        </div>
      </div>
    )
}

export default GreenhouseList

const JobItem = ({
  index,
  title,
  absolute_url: absoluteUrl,
  departments,
  id,
}) => {
  const department = getValue(departments, "0.name")

  return (
    <div className="grid grid-cols-12 col-gap-2 pb-4 border-b md:pb-8 lg:pb-8 border-dark-navy">
      <h3 className="col-span-5 pl-4 text-sm antialiased leading-7 lg:pl-8 md:text-2xl sm:mb-0 font-miller text-dark-navy">
        {title}
      </h3>
      <p className="col-span-5 pl-2 text-sm antialiased leading-7 md:pl-0 md:text-2xl font-miller text-dark-navy">
        {department}
      </p>
      <div className="col-span-2">
        <Link
          href={absoluteUrl}
          className="hidden md:inline-block"
          target="_blank"
        >
          Apply Now
        </Link>
        <a
          href={absoluteUrl}
          target="_blank"
          className="inline-block md:hidden"
          title="Apply Now"
        >
          <span className="sr-only">Apply Now</span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.332 6L9 7.41 13.327 12 9 16.59 10.332 18 16 12l-5.668-6z"
              fill="#15353D"
            />
          </svg>
        </a>
      </div>
    </div>
  )
}
